/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import types */
import type { SensorCsvRow } from '@/types/sensorCsv';

export interface SensorCsvSelection {
    deviceName: string;
    sensorType: string;
}

/**
 * Derives the selectable device and sensor type without changing the CSV value.
 * Neutraubling base devices expose P as their default selectable sensor type.
 */
export function getSensorCsvSelection(sensorName: string): SensorCsvSelection | null {
    const normalizedSensorName = sensorName.trim();

    if (/^GN\.[^.]+$/.test(normalizedSensorName)) {
        return {
            deviceName: normalizedSensorName,
            sensorType: 'P',
        };
    }

    const sensorParts = normalizedSensorName.split('.');

    if (sensorParts.length < 3) {
        return null;
    }

    return {
        deviceName: sensorParts.slice(0, 2).join('.'),
        sensorType: sensorParts.slice(2).join('.'),
    };
}
